<div class="l-wrapper">
  <app-header></app-header>
  <div class="l-contact">
    <div class="l-contact__img">
      <img
        src="./../../../../assets/img/contact-main.png"
        alt=""
        class="c-pc"
      />
      <img
        src="./../../../../assets/img/contact-sp-main.png"
        alt=""
        class="c-sp"
      />
    </div>
    <div class="l-contact__title">
      <h2 translate>
        {{ "contact.content1.title" }}
      </h2>
    </div>
    <form class="l-contact__content" [formGroup]="formGroup">
      <app-input
        label="contact.content2.label.name"
        [require]="false"
        placeholder=""
        formControlName="name"
      ></app-input>
      <app-input
        label="contact.content2.label.email"
        [require]="false"
        placeholder=""
        formControlName="email"
      ></app-input>
      <app-input
        label="contact.content2.label.companyName"
        [require]="false"
        placeholder=""
        formControlName="comany_name"
      ></app-input>
      <app-textarea
        label="contact.content2.label.content"
        [require]="false"
        placeholder=""
        formControlName="content"
      ></app-textarea>
      <button
        translate
        class="c-contact-button"
        type="button"
        (click)="onAccept()"
      >
        {{ "contact.content2.label.submitButton" }}
      </button>
    </form>
  </div>
  <app-footer></app-footer>
</div>
